import { NgModule } from '@angular/core';

import * as Auth from '@reg/shared/auth';
import * as Svc from '@reg/shared/service';

@NgModule({
    providers: [
        Svc.HttpServiceHelper,
        Svc.ToastService,
        Svc.SpinnerService,
        Svc.ConfigurationService,
        Svc.AuthService,
        Svc.WizardStepService,
        Svc.UserService,
        Auth.AuthGuard,
        Svc.MessageBoxService,
        Svc.ApprovalStatusService,
        Svc.AwsService,
        Svc.GoogleService,
        Svc.ContactService,
        Svc.CountryService,
        Svc.StateService,
        Svc.DivisionService,
        Svc.DivisionDiscountService,
        Svc.DivisionGroupingService,
        Svc.DivisionProfileService,
        Svc.DivisionRegistrationService,
        Svc.EmailMessageService,
        Svc.EmailRecipientService,
        Svc.EventService,
        Svc.EventCoreService,
        Svc.GradeService,
        Svc.GenderService,
        Svc.UsawMembershipService,
        Svc.MeasurementUnitService,
        Svc.OrderService,
        Svc.OrderTransactionService,
        Svc.OrderItemService,
        Svc.PaymentOptionTypeService,
        Svc.ProductService,
        Svc.ProductTypeService,
        Svc.ReferenceItemService,
        Svc.RegistrationTypeService,
        Svc.ScheduleItemService,
        Svc.SiteSettingsService,
        Svc.SkillLevelService,
        Svc.TeamService,
        Svc.TeamUserService,
        Svc.TeamContactService,
        Svc.TimeZoneService,
        Svc.ToRegistrantGroupTypeService,
        Svc.UsaWrestlingService,
        Svc.WeightClassService,
        Svc.WrestlerService,
        Svc.WrestlerWaiverService,
        Svc.UserAccountService,
        Svc.SecurityRoleService,
        Svc.PlanSubscriptionService,
        Svc.BoutAttributeService,
        Svc.OrganizationBoutAttributeService,
        Svc.BoutService,
        Svc.WinTypeService,
        Svc.DualService,
        Svc.DualScoreAdjustmentService,
        Svc.SeedingCriteriaTypeService,
        Svc.SeedingCriteriaService,
        Svc.WrestlerSeedingCriteriaService,
        Svc.MatService,
        Svc.ReportService,
        Svc.StripeAccountService,
        Svc.ExternalLinkService,
        Svc.ScriptService,
        Svc.SeasonEventService,
        Svc.OrderCouponService,
        Svc.AdditionalInfoService,
        Svc.AdditionalInfoItemService,
        Svc.IdentityTeamService,
        Svc.IdentityPersonService,
        Svc.IdentityUserService,
        Svc.IdentityClaimService,
        Svc.IdentityPermissionService,
        Svc.IdentityTeamRosterService,
        Svc.IdentityTeamContactService,
        Svc.IdentityReferenceItemService,
        Svc.IdentityAssessorService,
        Svc.IdentitySeasonService,
        Svc.IdentitySeasonBodyAssessSettingService,
        Svc.IdentityBodyAssessMethodService,
        Svc.IdentityBodyAssessReadingService,
        Svc.IdentityBodyAssessIneligibleService,
        Svc.IdentityBodyAssessWeighInService,
        Svc.IdentityBodyAssessService,
        Svc.IdentityCalendarItemService,
        Svc.IdentityTeamTagService,
        Svc.IdentityOrganizationService,
        Svc.IdentitySportService,
        Svc.IdentitySeasonGroupService,
        Svc.IdentityRankingPointsService,
        Svc.IdentityRankingPointsEventService,
        Svc.IdentityRankingGroupService,
    ],
})
export class ServicesModule {
}
